// Phase 10 — Notes module hook.

import { useQuery } from '@tanstack/react-query';

interface NotesEntry {
  id: string;
  title: string;
  body: string;
  tags: string;
  created_at: string;
  updated_at: string;
}

export function useNotes() {
  return useQuery<NotesEntry[]>({
    queryKey: ['notes', 'entries'],
    queryFn: async () => {
      const res = await fetch('/api/modules/notes/entries', {
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('Failed to load notes');
      return res.json();
    },
    staleTime: 30_000,
  });
}
